import {
  ArrowUp, ArrowDown, Eye, UserPlus, Check, Clock, ShoppingCart, DollarSign,
  Mail, Handshake, Heart, Pencil, MessagesSquare, Star, RefreshCw, Flag,
  LayoutDashboard, TrendingUp, Telescope, ChartBar, Filter, Users, Target,
  Brain, PlayCircle, Sparkles, Info, Sunrise, GitBranch, ShieldCheck, BookOpen, Archive, Landmark,
  CalendarRange, Plug, Milestone,
} from "lucide-react";

export const ICONS = {
  eye: Eye, "user-plus": UserPlus, check: Check, clock: Clock, "shopping-cart": ShoppingCart,
  "dollar-sign": DollarSign, mail: Mail, handshake: Handshake, heart: Heart, pencil: Pencil,
  "messages-square": MessagesSquare, star: Star, "refresh-cw": RefreshCw, flag: Flag,
};

export const TAB_ICONS = {
  summary: LayoutDashboard, velocity: TrendingUp, forecast: Telescope, mission: Heart,
  marketing: ChartBar, funnel: Filter, customers: Users, revenue: DollarSign, email: Mail,
  partners: Handshake, content: PlayCircle, goals: Target, advisor: Brain,
  brief: Sunrise, decisions: GitBranch, certify: ShieldCheck, knowledge: BookOpen, archive: Archive, baselines: Landmark,
  reporting: CalendarRange, integrations: Plug, timeline: Milestone,
};

export { ArrowUp, ArrowDown, Flag, Sparkles, PlayCircle, Info };

export function SectionLabel({ children }) {
  return <div className="section-label">{children}</div>;
}

export function DeltaText({ dir, children }) {
  const cls = dir === "up" ? "up" : dir === "down" ? "down" : "flat";
  return (
    <div className={`mc-delta ${cls}`}>
      {dir === "up" && <ArrowUp size={12} />}
      {dir === "down" && <ArrowDown size={12} />}
      <span>{children}</span>
    </div>
  );
}

export function MetricCard({ m }) {
  return (
    <div className="metric-card" data-testid={`metric-${(m.label || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <div className="mc-label">{m.label}</div>
      <div className="mc-value" style={m.small ? { fontSize: 14 } : (m.color ? { color: m.color } : undefined)}>{m.value}</div>
      {m.delta && <DeltaText dir={m.dir}>{m.delta}</DeltaText>}
    </div>
  );
}

export function MetricGrid({ items }) {
  return (
    <div className="metric-grid">
      {items.map((m, i) => <MetricCard key={i} m={m} />)}
    </div>
  );
}

export function SourceBars({ rows, max }) {
  const top = max ?? Math.max(...rows.map((r) => r.value ?? r.pct ?? 0));
  return (
    <>
      {rows.map((r, i) => {
        const raw = r.value ?? r.pct;
        const width = r.width != null ? r.width : Math.round(((raw ?? 0) / top) * 100);
        const label = r.value != null ? r.value.toLocaleString() : `${r.pct}%`;
        return (
          <div className="source-row" key={i}>
            <div className="source-dot" style={{ background: r.color }} />
            <div className="source-name">{r.name}</div>
            <div className="source-bar-track"><div className="source-bar-fill" style={{ width: `${width}%`, background: r.color }} /></div>
            <div className="source-val">{label}</div>
          </div>
        );
      })}
    </>
  );
}

export function FunnelBars({ stages }) {
  return (
    <>
      {stages.map((s, i) => (
        <div className="funnel-bar" key={i}>
          <div className="funnel-bar-label">
            <span>{s.label}{s.pct ? ` · ${s.pct}` : ""}</span>
            <span>{typeof s.value === "number" ? s.value.toLocaleString() : s.value}</span>
          </div>
          <div className="funnel-bar-track"><div className="funnel-bar-fill" style={{ width: `${s.width}%`, background: s.color }} /></div>
        </div>
      ))}
    </>
  );
}
